import React from 'react';
import { App } from '@gin-betting/core';
import { FormattedMessage } from 'react-intl';
import banners, { BannerTypes } from '@gin-betting/banners';

import { PromoItem, Carousel, Spinner } from 'components';
import { AsyncOddButton } from 'modules/betslip/async';
import favorite from 'modules/favorite';
import TopMatchTabs from '../TopMatchTabs';
import useTopMatch from './useTopMatch';
import messages from '../../messages';
import './topMatch.scss';

const {
    components: { ToggleFavoriteButton },
} = favorite;
const {
    hocs: { withAvailableZoneByAttributes },
} = banners;

const TopMatch: React.FC<BannerTypes.WithAvailableZoneProps> = ({ zoneId }) => {
    const {
        sports,
        sportEventIds,
        activeSportId,
        handleTabChange,
        preloadMatches,
        fetchStatus,
        isLoadingTimedOut,
    } = useTopMatch({ zoneId });

    if (sportEventIds.length === 0) {
        if (fetchStatus === App.FetchStatus.LOADING && !isLoadingTimedOut)
            return (
                <div styleName="spinner ">
                    <Spinner />
                </div>
            );

        return null;
    }

    return (
        <div styleName="container">
            <div styleName="header">
                <span styleName="header-title">
                    <FormattedMessage {...messages.topMatch} />
                </span>
            </div>

            <TopMatchTabs
                sports={sports}
                activeSportId={activeSportId}
                onTabChange={handleTabChange}
                onInactiveTabHover={preloadMatches}
            />

            <Carousel
                key={activeSportId}
                hasControls={true}
                direction="left"
                delay={20000}
            >
                {sportEventIds.map(matchId => (
                    <PromoItem
                        key={matchId}
                        matchId={matchId!}
                        AsyncOddButton={AsyncOddButton}
                        favoriteButton={
                            <ToggleFavoriteButton matchId={matchId} />
                        }
                    />
                ))}
            </Carousel>
        </div>
    );
};

export default withAvailableZoneByAttributes(TopMatch);
